import styled from '@emotion/styled';

const RING_COLOR = {
  RED: 'red',
  GREEN: 'green',
  ORANGE: 'orange',
} as const;

const RING_SIZE = {
  SMALL: 'small',
  BIG: 'big',
} as const;

const getBorderColor = (color, theme) => {
  let borderColor;
  switch (color) {
    case RING_COLOR.RED:
      borderColor = theme.colors?.red[600];
      break;
    case RING_COLOR.GREEN:
      borderColor = theme.colors?.green[600];
      break;
    case RING_COLOR.ORANGE:
      borderColor = theme.colors?.orange[300];
      break;
    default:
      borderColor = theme.colors?.green[600];
  }
  return borderColor;
};

const StyledRing = styled<any>('span')((props) => ({
  borderRadius: '50%',
  minHeight: props.size === RING_SIZE.SMALL ? '16px' : '20px',
  minWidth: props.size === RING_SIZE.SMALL ? '16px' : '20px',
  color: props.theme.colors?.white,
  border: '1px solid',
  borderColor: getBorderColor(props.color, props.theme),
}));

type RingProps = {
  color?: (typeof RING_COLOR)[keyof typeof RING_COLOR];
  size?: (typeof RING_SIZE)[keyof typeof RING_SIZE];
};

const Ring = ({ color, size }: Readonly<RingProps>) => {
  return <StyledRing color={color} size={size} />;
};

Ring.defaultProps = {
  size: RING_SIZE.SMALL,
};

export default Ring;
